import type { MessagingChannel } from "./api";
import { ChannelLogo } from "./ChannelLogo";
import { LinkedPill } from "./LinkedPill";

/** One bordered line: the channel's mark, the number (or name), and Linked when it is. */
export function ConnectionLine({
  channel,
  label,
  linked = false,
}: {
  channel: MessagingChannel;
  label: string;
  linked?: boolean;
}) {
  return (
    <div className="flex min-w-0 items-center gap-3 rounded-lg border p-3">
      <ChannelLogo channel={channel} linked={linked} />
      <span className="min-w-0 break-words font-medium">{label}</span>
      {linked && (
        <span className="ml-auto shrink-0">
          <LinkedPill />
        </span>
      )}
    </div>
  );
}
